module.exports = __webpack_public_path__ + "static/media/icon-header-partners.d649400f.svg";